import React, { Component } from "react";
import { withRouter } from "react-router";
import RequestsHistoryListing from "../requests_history/requests_history.list";
import store from "./filterStore";

class EntityInvoicesView extends Component {
  /**
   *
   */

  componentDidMount() {}

  /**
   *
   */

  render() {
    return (
      <>
        <div className="main-reqlist-container">
          <RequestsHistoryListing
            store={store}
            entity_id={this.props.match.params.id}
          />
        </div>
      </>
    );
  }
}

export default withRouter(EntityInvoicesView);
